import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO, { breadcrumbSchema } from "./SEO";

export function LegalLayout({ title, updated, children, seo }) {
  return (
    <>
      {seo && (
        <SEO
          title={seo.title || title}
          description={seo.description}
          path={seo.path}
          schema={breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: title, path: seo.path },
          ])}
        />
      )}
      <main className="pt-32 pb-24 bg-cream-50 min-h-screen">
        <div className="max-w-3xl mx-auto px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-brand hover:text-brand-dark mb-8"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <h1 className="font-display text-5xl md:text-6xl font-semibold text-granite-dark leading-[1.05]">
            {title}
          </h1>
          {updated && (
            <div className="text-sm text-granite/60 mt-3">Last updated: {updated}</div>
          )}
          <article className="prose-nina mt-10">{children}</article>
        </div>
      </main>
    </>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-2xl md:text-3xl font-semibold text-granite-dark mb-3">{heading}</h2>
      <div className="text-granite/80 leading-relaxed space-y-3 text-[15px]">{children}</div>
    </section>
  );
}
